import {
  ClientService,
  CommonService,
  DepositTerminologyService,
  SplashScreenStateService,
  SubscriptionService,
  ToastMessageService
} from '@fitness-force/api';
import { Router, RouterModule } from '@angular/router';
import {
  DatePipe,
  AsyncPipe,
  DecimalPipe,
  NgClass,
  TitleCasePipe,
} from '@angular/common';
import { Store } from '@ngrx/store';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnDestroy,
  input,
  output,
  inject,
} from '@angular/core';
import {
  Observable,
  BehaviorSubject,
  of,
  combineLatest,
  Subject,
} from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataGridComponent, NoComponentComponent } from '@fitness-force/grid';
import {
  getCutomDate,
  timeLineService,
  RouteStateService,
  getPaymentMethodDetails,
  PaymentMethodDisplayData,
  FeatureFlagService
} from '@fitness-force/shared-utils';
import { DividerModule } from 'primeng/divider';
import { TimelineModule } from 'primeng/timeline';

import { TableModule } from 'primeng/table';
import {
  AbstractControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { SelectModule } from 'primeng/select';
import { AvatarModule } from 'primeng/avatar';
import { TagModule } from 'primeng/tag';
import { StyleClassModule } from 'primeng/styleclass';
import { AppErrors } from '@fitness-force/models';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  PlanIntervalType,
  StaffStatus,
  Ienum,
  SubscriptionStatus,
  SignUpMode,
  PlanCategory,
  OccurenceType,
} from '@fitness-force/enum';
import { CONSTANTS_DATA } from '@fitness-force/constants';
import { InvoiceTabComponent } from '../../../transaction-tab/invoice-tab/invoice-tab.component';
import { FreezeListTabComponent } from '@fitness-force/freeze-lib';
import { DateTimeFormatPipe } from '@fitness-force/pipes/datetime-format';
import { CurrencyformatPipe } from '@fitness-force/pipes/currency';
import { CurrencyComponent } from '@fitness-force/grid-utility/currency';
import { InvoiceDetailsComponent } from '../../invoice-details/invoice-details.component';

import { MessageModule } from 'primeng/message';
import { DialogModule } from 'primeng/dialog';
import { TENANTS_INFO } from '@fitness-force/state';
import type {
  InvoiceOccurance,
  PaymentMethod,
  PlanAddons,
  PlanSummary,
  PlanSummaryClient,
  SubscriptionById,
  SubscriptionDeposit,
  TENANTSINTERFACE,
} from '@fitness-force/models';
import { PaymentTimelineComponent } from '../payment-timeline/payment-timeline.component';
import { SubscriptionServicesComponent } from '../subscription-services/subscription-services.component';
import { SubscriptionClientsComponent } from '../subscription-clients/subscription-clients.component';
import { SubscriptionStartEndDateEditComponent } from '../subscription-start-end-date-edit/subscription-start-end-date-edit.component';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { OverlayModule } from 'primeng/overlay';
import { PopoverModule } from 'primeng/popover';
import { BillingComponent } from '@fitness-force/billing';
import { SubscriptionActionListComponent } from '../../../subscription-action-list/subscription-action-list.component';
import { DepositNameComponent } from '../../../data-grid/utility/deposit-name/deposit-name.component';
import { SkeletonModule } from 'primeng/skeleton';
import { TooltipModule } from 'primeng/tooltip';
import {
  PendingActionsPopupComponent,
  PendingMandatoryActionDetails,
} from '../pending-actions-popup/pending-actions-popup.component';
import { GuestPassSummaryComponent } from './guest-pass-summary/guest-pass-summary.component';
import { GuestPassListTabComponent } from '../../../transaction-tab/guest-pass-list-tab/guest-pass-list-tab.component';

@Component({
  selector: 'subscription-details',
  templateUrl: './subscription-details.component.html',
  styleUrls: ['./subscription-details.component.scss'],
  providers: [ToastMessageService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    DividerModule,
    TimelineModule,
    DateTimeFormatPipe,
    CurrencyformatPipe,
    TableModule,
    ReactiveFormsModule,
    FormsModule,
    ButtonModule,
    RippleModule,
    SelectModule,
    AvatarModule,
    TagModule,
    StyleClassModule,
    DataGridComponent,
    InvoiceDetailsComponent,
    RouterModule,
    InvoiceTabComponent,
    MessageModule,
    DialogModule,
    SubscriptionServicesComponent,
    SubscriptionClientsComponent,
    PaymentTimelineComponent,
    SubscriptionStartEndDateEditComponent,
    ConfirmDialogModule,
    ConfirmPopupModule,
    OverlayModule,
    PopoverModule,
    BillingComponent,
    SubscriptionActionListComponent,
    SkeletonModule,
    PendingActionsPopupComponent,
    FreezeListTabComponent,
    TranslateModule,
    TooltipModule,
    AsyncPipe,
    DecimalPipe,
    NgClass,
    TitleCasePipe,
    GuestPassSummaryComponent,
    GuestPassListTabComponent,
  ],
})
export class SubscriptionDetailsComponent implements OnInit, OnDestroy {
  private readonly store = inject(Store);
  private readonly translate = inject(TranslateService);
  private readonly depositTerminologyService = inject(DepositTerminologyService);
  private readonly clientService = inject(ClientService);
  private readonly toastMessageService = inject(ToastMessageService);
  private readonly router = inject(Router);
  datePipe = inject(DatePipe);
  private readonly fb = inject(UntypedFormBuilder);
  cd = inject(ChangeDetectorRef);
  private readonly routerservice = inject(RouteStateService);
  splashScreen = inject(SplashScreenStateService);
  private readonly commonService = inject(CommonService);
  private readonly featureFlagService = inject(FeatureFlagService);
  private readonly subscriptionService = inject(SubscriptionService);

  readonly clientId = input<number>(0);
  readonly subscriptionId = input<number>(0);
  localSubscriptionId: number = 0;
  readonly emitEvents = output<any>();
  readonly selectedSubscription = input<any>(undefined, {
    alias: 'subscription',
  });
  readonly allSubscription = input<any>();

  tenantId: number = 0;
  subscriptionDetailsContract: boolean = false;
  paymentTimeline: any[] = [];
  paymentStatus: any[] = [];
  subscriptionDetailsPaidFull: boolean = false;
  subscriptionDetailsDropin: boolean = false;
  showsubscriptionDetails: boolean = false;
  clientSubScriptionId: number | null = null;
  invoiceData = new BehaviorSubject<any>([]);
  paymentTimelineData = new BehaviorSubject<InvoiceOccurance[]>([]);
  clientSubscriptionData = new BehaviorSubject<any>({});
  columns: any = new BehaviorSubject([]);
  showBulkActionBar = false;
  selecallInvoiceData = new BehaviorSubject(false);
  emptyStateComponent$ = new BehaviorSubject<any>(NoComponentComponent);
  allParams = new Map();
  totalRecordLength = new BehaviorSubject({
    totalPage: 10,
    totalItems: 10,
    currentPage: 0,
  });
  invoiceDetails: any;
  invoiceId: any;
  showInvoicePopup: boolean = false;
  assignSessionOwnerModal = false;
  _sessionOwner = new BehaviorSubject<number[]>([0]);
  getAccessedStaffList$: Observable<any> | any;
  showSessionOwner: boolean = false;
  currentYear = new Date();
  subscriptionService$ = new BehaviorSubject<any[]>([]);
  serviceTablecolumns$: any = new BehaviorSubject([]);
  showAddonSidebar: boolean = false;
  showBillingSidebar = false;
  showPaymentStatusSidebar = false;

  showDeposit: boolean = false;

  weekDays = [
    { key: 'Sunday', value: -1 },
    { key: 'Monday', value: -2 },
    { key: 'Tuesday', value: -3 },
    { key: 'Wednesday', value: -4 },
    { key: 'Thursday', value: -5 },
    { key: 'Friday', value: -6 },
    { key: 'Saturday', value: -7 },
  ];

  days: Array<string> = CONSTANTS_DATA.DAYS;
  contractExpiry: any[] = [];
  changeSessionOwnerForm: UntypedFormGroup = new UntypedFormGroup({});
  currentDate: Date = new Date();
  allServices = new BehaviorSubject<any>([]);
  showCancelSubscription: boolean = false;
  showEditStartEndDate: boolean = false;
  subscriptionById: SubscriptionById;
  membershipId: number = 0;
  showVoidSubscriptionModal: boolean = false;
  voidSubscriptionForm: UntypedFormGroup = new UntypedFormGroup({});
  ActivateMebershipForm: UntypedFormGroup = new UntypedFormGroup({});
  subscriptionDetails: any;
  btnLoading = new BehaviorSubject<boolean>(false);
  allTenants: any;
  showTransfer: boolean = false;
  error = new BehaviorSubject(null as AppErrors | null);
  showErrorPopup = new BehaviorSubject(false);
  errorMessages = [] as any;

  upgradedSubscription: boolean = false;
  ActivateMembershipPopup: boolean = false;
  addDiscountedPeriod: boolean = false;
  clientDetails: any;
  showFreeDiscountApply = new BehaviorSubject(false);
  selectedAddons = new BehaviorSubject<PlanAddons[]>([]);
  planId: number = 0;
  planSummarydataObject: Observable<PlanSummary> | any;
  depositsTableData: any[];
  depositTablecolumns: any = new BehaviorSubject([]);
  depositTableData = new BehaviorSubject<SubscriptionDeposit[]>([]);
  isTenantPresale = new BehaviorSubject<boolean>(false);
  showSkeleton$ = new BehaviorSubject<boolean>(true);
  showPaymentTimelineSkeleton$ = new BehaviorSubject<boolean>(true);
  showPendingActionsPopup: boolean = false;
  selectedPendingDetails: PendingMandatoryActionDetails | null = null;
  selectedSubscriptionAutopay: boolean = false;
  private readonly destroy$ = new Subject<void>();
  selectedSubscriptionIsRecurring: boolean = false;
  showClearOverrideModal = false;
  clearOverrideBtnLoading = false;
  clearOverrideForm: UntypedFormGroup = new UntypedFormGroup({});
  showSubscriptionStatusOverride = new BehaviorSubject<boolean>(false);

  constructor() {
    this.depositsTableData = [
      {
        deposits: 'Deposit 1',
        auto_apply: true,
        occurence: '11 Billing Occurrence',
        status: 'Applied',
        amount: '$2500.00',
      },
      {
        deposits: 'Deposit 2',
        auto_apply: true,
        occurence: 'Last Billing Occurrence',
        status: 'Scheduled',
        amount: '$1900.00',
      },
      {
        deposits: 'Deposit 3',
        auto_apply: false,
        occurence: '',
        status: 'Pending',
        amount: '$3000.00',
      },
    ];
  }

  ngOnInit(): void {
    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      this.allTenants = tenant.all_tenant;
    });

    // Check all feature flags using combineLatest for cleaner code
    // This waits for Statsig initialization and updates all flags at once
    combineLatest([
      this.featureFlagService.getFlag$('show_transfer'),
      this.featureFlagService.getFlag$('show_add_discount_on_billing_cycle'),
      this.featureFlagService.getFlag$('show_subscription_status_override'),
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([showTransfer, showDiscountOnBillingCycle, showSubscriptionStatusOverride]) => {
        this.showTransfer = showTransfer;
        this.showFreeDiscountApply.next(showDiscountOnBillingCycle);
        this.showSubscriptionStatusOverride.next(showSubscriptionStatusOverride);
        this.cd.detectChanges();
      });

    this.componentInit();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  componentInit() {
    this.allParams.set('PageNumber', { name: 'PageNumber', value: 1 });
    this.allParams.set('PageSize', { name: 'PageSize', value: 10 });
    this.voidSubscriptionForm = this.fb.group({
      void_reason: ['', [Validators.required]],
    });
    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
    });
    this.ActivateMebershipForm = this.fb.group({
      change_reason: ['', [Validators.required]],
    });

    this.clearOverrideForm = this.fb.group({
      override_change_reason: ['', [Validators.required]],
    });

    this.store.select(TENANTS_INFO).subscribe((res: TENANTSINTERFACE) => {
      if (res) {
        this.isTenantPresale.next(
          res.all_tenant
            .find((o) => o.id == this.tenantId)
            ?.status.toLowerCase() === 'presales',
        );
      }
    });

    this.selectedSubscriptionIsRecurring = this.isRecurringSubscription(
      this.selectedSubscription(),
    );
    this.getSubscriptionDetailsById();
  }

  getSubscriptionDetailsById() {
   this.clientService.getSubscriptionDetails(
        this.clientId(),
        this.subscriptionId(),
      ).pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          const subscription = response as SubscriptionById;
          subscription.scheduled_cancellation_date =
            this.isMinimumDateTimeValue(
              subscription.scheduled_cancellation_date,
            )
              ? subscription.scheduled_cancellation_date
              : subscription.scheduled_cancellation_date;
          this.planId = subscription.plan_id;
          this.clientSubscriptionData.next(subscription);
          this.subscriptionById = subscription;
          // this.paymentTimelineData.next(
          //   response.paymentTimeline.invoice_occurance
          //     ? response.paymentTimeline.invoice_occurance
          //     : [],
          // );
          if(this.selectedSubscriptionIsRecurring) {
            this.getPaymentTimeline();
          }
          else {
            this.paymentTimelineData.next([]);
            this.showPaymentTimelineSkeleton$.next(false);
            this.cd.detectChanges();
          }
          this.SetDepositDetails();
          this.showSkeleton$.next(false);
        },
        error: (error: any) => {
          this.toastMessageService.showError(error);
        },
        complete: () => {
          this.cd.detectChanges();
        },
      });

    this.cd.detectChanges();
  }

  getSubscription(subscriptionId: number) {
    this.localSubscriptionId = subscriptionId;
    this.paymentTimelineData.next([]);
    this.clientSubscriptionData.next(null);
    this.getSubscriptionDetailsById();
    this.cd.detectChanges();
  }

  getPaymentTimeline() {
    this.showPaymentTimelineSkeleton$.next(true);
    this.cd.detectChanges();
    this.clientService.getPaymentTimeline(
      this.clientId(),
      this.subscriptionId(),
    ).pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (response: any) => {
      this.paymentTimelineData.next(response.invoice_occurance ? response.invoice_occurance : []);
      this.showPaymentTimelineSkeleton$.next(false);
      this.cd.detectChanges();
      },
      error: (error: any) => {
        this.paymentTimelineData.next([]);
        this.showPaymentTimelineSkeleton$.next(false);
        this.cd.detectChanges();
        this.toastMessageService.showError(error);
      },
      complete: () => {
        this.showPaymentTimelineSkeleton$.next(false);
        this.cd.detectChanges();
      },
    });
  }

  onPaymentTimelineRefreshed(timelineData: InvoiceOccurance[]): void {
    this.paymentTimelineData.next(timelineData);
    this.cd.detectChanges();
  }

  handleEvent(e: any) {
    this.componentInit();
  }

  handleSelectAll(selection: any) {
    if (selection.checked) {
      this.showBulkActionBar = true;
    } else {
      this.showBulkActionBar = false;
    }
  }

  formatDate(d: any) {
    const parseDate = `${d.getFullYear()}-${d.getMonth() > 9 ? d.getMonth() : d.getMonth() + 1}-${d.getDate()}`;
    return parseDate.toString();
  }

  BacktoAllSubscriptions() {
    this.subscriptionDetailsContract = false;
    this.subscriptionDetailsPaidFull = false;
    this.subscriptionDetailsDropin = false;
    this.showsubscriptionDetails = false;
  }

  showAllSubscriptions() {
    if (
      this.subscriptionDetailsContract == false &&
      this.subscriptionDetailsPaidFull == false &&
      this.subscriptionDetailsDropin == false
    ) {
      return true;
    } else {
      return false;
    }
  }

  billingInterval(interval_type: string, interval_value: number): string {
    if (
      interval_value &&
      interval_type.toLowerCase() == 'month' &&
      interval_value
    ) {
      if (interval_value == 1) {
        return 'Month';
      } else if (interval_value == 3) {
        return 'Quater';
      } else if (interval_value == 6) {
        return 'Half yearly';
      } else {
        return interval_type;
      }
    } else {
      return interval_type;
    }
  }
  ordinalSuffixOfBillingCycle(billingCycleDate: number) {
    const billingCycleDateBuff = billingCycleDate % 10;
    const billingCycleDateBuffAvg = billingCycleDate % 100;
    if (billingCycleDateBuff == 1 && billingCycleDateBuffAvg != 11) {
      return 'st';
    }
    if (billingCycleDateBuff == 2 && billingCycleDateBuffAvg != 12) {
      return 'nd';
    }
    if (billingCycleDateBuff == 3 && billingCycleDateBuffAvg != 13) {
      return 'rd';
    }
    return 'th';
  }

  GetBillingFrequency(
    interval_type: string,
    interval_value: number,
    billingCycleDay: number,
  ): string {
    let translate: string = '';
    if (interval_value && interval_type.toLowerCase() == 'month') {
      const ordinalSuffix = this.ordinalSuffixOfBillingCycle(billingCycleDay);
      if (interval_value == 1) {
        this.translate
          .get('SUBSCRIPTIONS.ONE_MONTH_TYPE', {
            billingCycleDay: billingCycleDay,
            ordinalSuffix: ordinalSuffix,
          })
          .subscribe((trans) => {
            translate = trans;
          });
      } else if (interval_value == 2) {
        this.translate
          .get('SUBSCRIPTIONS.TWO_MONTH_TYPE', {
            billingCycleDay: billingCycleDay,
            ordinalSuffix: ordinalSuffix,
          })
          .subscribe((trans) => {
            translate = trans;
          });
      } else if (interval_value == 3) {
        this.translate
          .get('SUBSCRIPTIONS.THREE_MONTH_TYPE', {
            billingCycleDay: billingCycleDay,
            ordinalSuffix: ordinalSuffix,
          })
          .subscribe((trans) => {
            translate = trans;
          });
      } else {
        this.translate
          .get('SUBSCRIPTIONS.MORE_MONTH_TYPE', {
            intervalValue: interval_value,
            billingCycleDay: billingCycleDay,
            ordinalSuffix: ordinalSuffix,
          })
          .subscribe((trans) => {
            translate = trans;
          });
      }
      return translate;
    } else if (interval_value && interval_type.toLowerCase() == 'week') {
      let day: string = '';

      if (billingCycleDay == 0)
        day =
          this.days[
            new Date(this.clientSubscriptionData.value.sign_up_date).getDay()
          ];
      else
        day = this.weekDays.find((d) => d.value == billingCycleDay)?.key || '';

      if (interval_value == 1) {
        this.translate
          .get('SUBSCRIPTIONS.WEEKLY_SUNDAY', { day: day })
          .subscribe((trans) => {
            translate = trans;
          });
      } else if (interval_value == 2) {
        this.translate
          .get('SUBSCRIPTIONS.2WEEK_SUNDAY', { day: day })
          .subscribe((trans) => {
            translate = trans;
          });
      } else {
        this.translate
          .get('SUBSCRIPTIONS.MORE_WEEK', {
            intervalType: interval_value,
            day: day,
          })
          .subscribe((trans) => {
            translate = trans;
          });
      }
      return translate;
    } else {
      return interval_type;
    }
  }

  transFerInitials(maxAllowedDays: any, startDate: any) {
    const transferAllowedDate = timeLineService(
      getCutomDate(maxAllowedDays, startDate),
    );
    return transferAllowedDate.type == 'ago'
      ? '0 Days'
      : transferAllowedDate.label;
  }

  cancellationDateAllowed(date: any) {
    timeLineService;
    return timeLineService(date);
  }

  isDefaultDate(date: string): boolean {
    const year = new Date(date).getFullYear();
    return year == 9999;
  }

  backToSubscription() {
    this.router.navigate(['/client/profile', this.clientId()]);
  }

  getInterval(
    billing_interval_value: number,
    billing_interval_type: PlanIntervalType,
  ) {
    let str: string = '';
    if (
      billing_interval_type == PlanIntervalType.Month ||
      billing_interval_type?.toString() ==
        PlanIntervalType[PlanIntervalType.Month]
    ) {
      if (billing_interval_value > 1) str = 'months';
      else str = 'month';
    } else if (
      billing_interval_type == PlanIntervalType.Week ||
      billing_interval_type.toString() ==
        PlanIntervalType[PlanIntervalType.Week]
    ) {
      if (billing_interval_value > 1) str = 'weeks';
      else str = 'week';
    } else if (
      billing_interval_type == PlanIntervalType.Day ||
      billing_interval_type == PlanIntervalType[PlanIntervalType.Day]
    ) {
      if (billing_interval_value > 1) str = 'days';
      else str = 'day';
    }
    return str.toUpperCase();
  }

  onActionEvent(event: any) {
    switch (event.action) {
      case 'openinvoice':
        {
          this.OpenInvoicePopup(event.columnData);
        }
        break;
    }
  }

  OpenInvoicePopup(invoiceNumber: string) {
    this.invoiceDetails = this.invoiceData.value.find(
      (i: { number_prefix: string }) => i.number_prefix == invoiceNumber,
    );
    this.invoiceId = this.invoiceDetails.id;
    this.showInvoicePopup = true;
  }

  closeInvoicePopup(event: any) {
    this.showInvoicePopup = event;
  }

  getSessionOwnerFC(serviceId: string): AbstractControl | null {
    return this.changeSessionOwnerForm.get(serviceId);
  }

  ShowToastErrors(error: any) {
    this.toastMessageService.showError(error);
  }

  getAllServices() {
    const services: any = [];
    if (
      this.clientSubscriptionData?.value.recurring_template_recurring_services
    ) {
      this.clientSubscriptionData.value.recurring_template_recurring_services.forEach(
        (value: any) => {
          if (value.service_behaviour == 'AppointmentPackage') {
            services.push(value);
            this.showSessionOwner = true;
            this.changeSessionOwnerForm.addControl(
              'SelectedAssignedFormControl_' + value.service_id.toString(),
              new UntypedFormControl(value.service_session_owner_id, []),
            );
          }
        },
      );
    }
    if (
      this.clientSubscriptionData?.value.recurring_template_non_recurring_services
    ) {
      this.clientSubscriptionData.value.recurring_template_non_recurring_services.forEach(
        (value: any) => {
          if (value.service_behaviour == 'AppointmentPackage') {
            services.push(value);
            this.showSessionOwner = true;
            this.changeSessionOwnerForm.addControl(
              'SelectedAssignedFormControl_' + value.service_id.toString(),
              new UntypedFormControl(value.service_session_owner_id, []),
            );
          }
        },
      );
    }
    this.allServices.next(services);
    return this.allServices;
  }

  get OStaffStatus(): Ienum<StaffStatus>[] {
    return Object.entries(StaffStatus)
      .filter((key) => typeof key[1] != 'number')
      .map(([key, value]) => ({ key, value }));
  }

  getSessionOwnerId(sessionOwnerId: number) {
    return new BehaviorSubject(sessionOwnerId);
  }

  isDateStartingAfterToday(startDate: Date) {
    return (
      startDate.getFullYear() > this.currentDate.getFullYear() &&
      startDate.getDate() > this.currentDate.getDate() &&
      startDate.getMonth() > this.currentDate.getMonth()
    );
  }

  dateTransform(date: Date) {
    return this.datePipe.transform(date, 'dd MMM yyyy');
  }

  isMinimumDateTimeValue(eta: Date): boolean {
    return (
      new Date(eta).getTime() === new Date('0001-01-01T00:00:00').getTime()
    );
  }

  GoToCancel(subscription: any) {
    this.showCancelSubscription = true;
  }

  closeEvent(event: any) {
    this.showCancelSubscription = false;
    this.clientSubscriptionData.next(event);
  }

  showWaringMessage() {
    this.translate
      .get('SUBSCRIPTIONS.SUBSCRIPTION_CANCELLED')
      .subscribe((translation) => {
        this.toastMessageService.showInfo(translation);
      });
  }

  closeDateChangeEvent(event: any) {
    this.showEditStartEndDate = false;
    this.subscriptionById = event;
    this.clientSubscriptionData.next(event);
  }

  reloadData(event: boolean) {
    if (event) this.componentInit();
  }

  showSubscriptionStatus(status: string) {
    let colorCode: string = '';
    const data = SubscriptionStatus[status as keyof typeof SubscriptionStatus];
    switch (data) {
      case SubscriptionStatus.Active:
        colorCode = 'bg-green-500';
        break;
      case SubscriptionStatus.Future:
        colorCode = 'bg-blue-500';
        break;
      case SubscriptionStatus.Cancelled:
        colorCode = 'bg-bluegray-500';
        break;
      case SubscriptionStatus.Frozen:
        colorCode = 'bg-cyan-500';
        break;
      case SubscriptionStatus.CancelledDueToNonPayment:
        colorCode = 'surface-500';
        break;
      case SubscriptionStatus.NotRenewing:
        colorCode = 'surface-500';
        break;
      case SubscriptionStatus.PendingForMandatoryAction:
        colorCode = 'bg-pink-500';
        break;
      case SubscriptionStatus.PendingForPaymentConfirmation:
        colorCode = 'bg-orange-500';
        break;
      case SubscriptionStatus.SuspendedDueToNonPayment:
        colorCode = 'surface-600';
        break;
      case SubscriptionStatus.Transfered:
        colorCode = 'bg-indigo-500';
        break;
      case SubscriptionStatus.Upgraded:
        colorCode = 'bg-teal-500';
        break;
      case SubscriptionStatus.Expired:
        colorCode = 'bg-red-500';
        break;
      case SubscriptionStatus.Void:
        colorCode = 'surface-500';
        break;
    }
    return colorCode;
  }

  isRecurringSubscription(subscription: any) {
    return (
      subscription.subscription_category == PlanCategory.Contract ||
      subscription.subscription_category.toString() ==
        PlanCategory[PlanCategory.Contract] ||
      subscription.subscription_category == PlanCategory.PayAsYouGo ||
      subscription.subscription_category.toString() ==
        PlanCategory[PlanCategory.PayAsYouGo]
    );
  }

  isBillingStopped(subscription: { stop_billing?: boolean }): boolean {
    return subscription?.stop_billing === true;
  }

  isStatusOverridden(subscription: { is_status_overridden?: boolean }): boolean {
    return subscription?.is_status_overridden === true;
  }

  openClearOverrideModal(): void {
    this.clearOverrideForm.reset();
    this.showClearOverrideModal = true;
    this.cd.detectChanges();
  }

  closeClearOverrideModal(): void {
    this.showClearOverrideModal = false;
    this.clearOverrideBtnLoading = false;
    this.clearOverrideForm.reset();
    this.cd.detectChanges();
  }

  submitClearOverride(): void {
    if (!this.clearOverrideForm.valid) {
      Object.keys(this.clearOverrideForm.controls).forEach((field) => {
        this.clearOverrideForm.get(field)?.markAsTouched({ onlySelf: true });
      });
      return;
    }

    this.clearOverrideBtnLoading = true;
    this.subscriptionService
      .clearStatusOverride(
        this.clientId(),
        this.subscriptionId(),
        this.clearOverrideForm.value.override_change_reason,
      )
      .subscribe({
        next: () => {
          this.translate
            .get('SUBSCRIPTIONS.MSG_CLEAR_OVERRIDE_SUCCESS')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.clearOverrideBtnLoading = false;
          this.closeClearOverrideModal();
          this.componentInit();
          this.emitEvents.emit(true);
          this.cd.detectChanges();
        },
        error: (error: AppErrors) => {
          this.clearOverrideBtnLoading = false;
          this.toastMessageService.showError(error);
          this.cd.detectChanges();
        },
      });
  }

  get ClearOverrideReasonFormControl(): UntypedFormControl {
    return this.clearOverrideForm.controls
      .override_change_reason as UntypedFormControl;
  }

  hasSubscription(subscription: any) {
    return subscription && Object.keys(subscription).length > 0;
  }

  hasUpgradeSubscription(subscription: any) {
    return (
      subscription.upgrade_from_clt_subs_id > 0 ||
      subscription.upgrade_to_clt_subs_id > 0
    );
  }

  isPayAsYouGoSubscription(subscription: any) {
    return (
      subscription.subscription_category == PlanCategory.ConvertToPayAsYouGo ||
      subscription.subscription_category.toString() ==
        PlanCategory[PlanCategory.ConvertToPayAsYouGo]
    );
  }

  get SubscriptonStatus() {
    return SubscriptionStatus;
  }

  get VoidReasonFormControl(): UntypedFormControl {
    return this.voidSubscriptionForm.controls.void_reason as UntypedFormControl;
  }

  get ChangeReasonFormControl(): UntypedFormControl {
    return this.ActivateMebershipForm.controls
      .change_reason as UntypedFormControl;
  }

  IsSubscrptionVoidOrCancelled(status: string) {
    const subscrptionStatus =
      SubscriptionStatus[status as keyof typeof SubscriptionStatus];
    return (
      subscrptionStatus == SubscriptionStatus.Void ||
      subscrptionStatus == SubscriptionStatus.Cancelled ||
      subscrptionStatus == SubscriptionStatus.Upgraded
    );
  }

  CanEditDates(status: string) {
    const subscrptionStatus =
      SubscriptionStatus[status as keyof typeof SubscriptionStatus];
    return (
      subscrptionStatus == SubscriptionStatus.Void ||
      subscrptionStatus == SubscriptionStatus.Cancelled ||
      subscrptionStatus == SubscriptionStatus.Frozen ||
      subscrptionStatus == SubscriptionStatus.SuspendedDueToNonPayment ||
      subscrptionStatus == SubscriptionStatus.Upgraded ||
      subscrptionStatus == SubscriptionStatus.Transfered ||
      subscrptionStatus == SubscriptionStatus.NotRenewing ||
      subscrptionStatus == SubscriptionStatus.CancelledDueToNonPayment
    );
  }

  getTenant(tenantId: number) {
    return this.allTenants.find((o: { id: number }) => o.id == tenantId);
  }

  get IsUpgraded() {
    return (
      this.subscriptionById &&
      this.subscriptionById.upgrade_from_clt_subs_id > 0
    );
  }

  isParentSubscription(): boolean {
    if (!this.subscriptionById) return false;
    const ownerSubsId = this.subscriptionById.family_owner_subs_id || 0;
    const currentSubsId =
      (this.subscriptionById as any).clt_subs_id || this.subscriptionById.id;
    return ownerSubsId > 0 && ownerSubsId === currentSubsId;
  }

  isChildSubscription(): boolean {
    if (!this.subscriptionById) return false;
    const ownerClientId =
      (this.subscriptionById as any).clt_subs_family_owner_client_id ||
      (this.subscriptionById as any).family_owner_client_id ||
      0;
    const currentSubsId =
      (this.subscriptionById as any).clt_subs_id || this.subscriptionById.id;
    const ownerSubsId = this.subscriptionById.family_owner_subs_id || 0;
    const isFamilyChild =
      (this.subscriptionById as any).clt_subs_is_family_child ??
      (this.subscriptionById as any).is_family_child;
    return (
      ownerClientId > 0 && ownerSubsId !== currentSubsId && !!isFamilyChild
    );
  }

  getSubscriptionDetails(subscription: any) {
    const subscrptionStatus =
      SubscriptionStatus[
        subscription.status as keyof typeof SubscriptionStatus
      ];
    if (subscrptionStatus == SubscriptionStatus.Upgraded)
      return this.allSubscription().find(
        (o: { id: any }) => o.id == subscription.upgrade_to_clt_subs_id,
      );
    else if (
      subscrptionStatus == SubscriptionStatus.Active &&
      subscription.upgrade_to_clt_subs_id > 0
    )
      return this.allSubscription().find(
        (o: { id: any }) => o.id == subscription.upgrade_to_clt_subs_id,
      );
    else
      return this.allSubscription().find(
        (o: { id: any }) => o.id == subscription.upgrade_from_clt_subs_id,
      );
  }

  hasTransferInfo(subscription: any): boolean {
    return !!(
      subscription?.transfer_type &&
      (subscription.transfer_from_tenant_id > 0 ||
        subscription.transfer_to_tenant_id > 0 ||
        subscription.transfer_from_client?.id > 0 ||
        subscription.transfer_to_client?.id > 0)
    );
  }

  isLocationTransfer(subscription: any): boolean {
    return subscription?.transfer_type === 'LocationToLocation';
  }

  getTransferFromName(subscription: any): string {
    if (this.isLocationTransfer(subscription)) {
      const tenant = this.allTenants?.find(
        (o: { id: number }) => o.id == subscription.transfer_from_tenant_id,
      );
      return (
        tenant?.name_primary_language || tenant?.name_secondary_language || ''
      );
    }
    return subscription.transfer_from_client?.full_name || '';
  }

  getTransferToName(subscription: any): string {
    if (this.isLocationTransfer(subscription)) {
      const tenant = this.allTenants?.find(
        (o: { id: number }) => o.id == subscription.transfer_to_tenant_id,
      );
      return (
        tenant?.name_primary_language || tenant?.name_secondary_language || ''
      );
    }
    return subscription.transfer_to_client?.full_name || '';
  }

  getTransferFromId(subscription: any): number {
    if (this.isLocationTransfer(subscription)) {
      return subscription.transfer_from_tenant_id;
    }
    return subscription.transfer_from_client?.id || 0;
  }

  getTransferToId(subscription: any): number {
    if (this.isLocationTransfer(subscription)) {
      return subscription.transfer_to_tenant_id;
    }
    return subscription.transfer_to_client?.id || 0;
  }

  isTransferredFrom(subscription: any): boolean {
    if (this.isLocationTransfer(subscription)) {
      return (
        subscription.transfer_from_tenant_id > 0 &&
        subscription.transfer_from_tenant_id !== this.tenantId
      );
    }
    // Show "transferred from X" when the current client is the recipient (transfer_to)
    return (
      subscription.transfer_to_client?.id === this.clientId() &&
      subscription.transfer_from_client?.id > 0
    );
  }

  isTransferredTo(subscription: any): boolean {
    if (this.isLocationTransfer(subscription)) {
      return (
        subscription.transfer_to_tenant_id > 0 &&
        subscription.transfer_to_tenant_id !== this.tenantId
      );
    }
    // Show "transferred to X" when the current client is the sender (transfer_from)
    return (
      subscription.transfer_from_client?.id === this.clientId() &&
      subscription.transfer_to_client?.id > 0
    );
  }

  PaymentMethodDetails(paymentMethod: PaymentMethod): PaymentMethodDisplayData {
    return getPaymentMethodDetails(paymentMethod, this.translate);
  }

  closeAddonSidebar(event: { event: any; subscription: any }) {
    this.showAddonSidebar = false;
    this.splashScreen.showSpinner();
    this.cd.detectChanges();
    this.selectedAddons.next(event.event.selectedAddons);
    if (this.selectedAddons.value.length > 0 && event.event.callbreakup) {
      const client = this.routerservice.getClient();
      const planSummaryClient = {} as PlanSummaryClient;
      planSummaryClient.client_id = this.clientId();
      planSummaryClient.client_name = client?.full_name || '';
      planSummaryClient.client_keyfob = client!.current_keyfob;
      planSummaryClient.client_image = client!.image;
      if (client!.client_status)
        planSummaryClient.client_status = client!.client_status.toString();

      const planSummary = {} as PlanSummary;
      planSummary.id = this.planId;
      planSummary.company_id = this.subscriptionById.company_id;
      planSummary.tenant_id = this.subscriptionById.tenant_id;
      planSummary.plan_selectable = false;
      planSummary.client = planSummaryClient;
      planSummary.from_subscription_id = this.subscriptionById.id;
      planSummary.SignUpMode = SignUpMode.MidCycleAddons;
      planSummary.addons = this.selectedAddons.value;
      this.planSummarydataObject = of(planSummary);
      setTimeout(() => {
        this.showBillingSidebar = true;
        this.splashScreen.hideSpinner();
        this.cd.detectChanges();
      }, 300);
    } else {
      this.showBillingSidebar = false;
      this.splashScreen.hideSpinner();
      this.cd.detectChanges();
    }
  }

  HideBillingSummary(event: any) {
    this.showBillingSidebar = false;
    this.showAddonSidebar = false;
  }

  GoToClientDetails(event: any) {
    this.showBillingSidebar = false;
    this.showAddonSidebar = false;
  }

  isNotRenewingStatus(status: string) {
    const subscrptionStatus =
      SubscriptionStatus[status as keyof typeof SubscriptionStatus];
    return subscrptionStatus == SubscriptionStatus.NotRenewing;
  }

  SetDepositDetails() {
    if (
      this.subscriptionById?.subscription_deposit &&
      this.subscriptionById.subscription_deposit.length > 0
    ) {
      this.showDeposit = true;
      const addedDeposits: any = [];
      this.subscriptionById.subscription_deposit.forEach(
        (element: any, index: number) => {
          const deposit: SubscriptionDeposit = {} as SubscriptionDeposit;
          const occurences = this.commonService.generateDepositOccurence(
            element.occurence_type,
            this.subscriptionById.subscription_category == PlanCategory.Contract
              ? this.subscriptionById.contract_term
              : 24,
          );
          deposit.occurence_to_apply = element.occurence_to_apply;
          deposit.occurence_type = element.occurence_type;
          deposit.occurence_amount_in_minor_currency =
            element.occurence_amount_in_minor_currency;
          if (
            element.occurence_type == OccurenceType.ApplyManually ||
            element.occurence_type.toString() ==
              OccurenceType[OccurenceType.ApplyManually]
          ) {
            deposit.occurence_to_apply = element.occurence_to_apply;
            deposit.occurence_name = '-';
          } else {
            deposit.occurence_name =
              occurences.find((o) => o.value == element.occurence_to_apply)
                ?.key || '';
          }
          this.depositTerminologyService
            .get('DEPOSIT.DEPOSIT_NAME', { count: index + 1 })
            .subscribe((translations) => {
              deposit.deposit_name = translations;
            });
          addedDeposits.push(deposit);
        },
      );
      this.depositTableData.next(addedDeposits);
      this.columnTranslate();
    } else {
      this.showDeposit = false;
    }
  }

  columnTranslate() {
    this.depositTerminologyService
      .get(['DEPOSIT.DEPOSIT', 'DEPOSIT.OCCURRENCE', 'DEPOSIT.AMOUNT'])
      .subscribe((translations) => {
        this.SetDepositColumns(translations);
      });
  }

  SetDepositColumns(translations: any) {
    const column = {
      deposit: translations['DEPOSIT.DEPOSIT'],
      occurence: translations['DEPOSIT.OCCURRENCE'],
      amount: translations['DEPOSIT.AMOUNT'],
    };
    this.depositTablecolumns.next([
      {
        title: column.deposit,
        classes: 'py-2  white-space-nowrap bold relative  capitalize',
        dataProperty: 'deposit_name',
        type: 'component',
        data: {
          name: DepositNameComponent,
        },
      },
      {
        title: column.occurence,
        classes: 'py-2  white-space-nowrap bold relative  capitalize',
        dataProperty: 'occurence_name',
        type: 'default',
      },
      {
        title: column.amount,
        classes: 'py-2  white-space-nowrap bold relative  capitalize',
        dataProperty: 'occurence_amount_in_minor_currency',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'occurence_amount_in_minor_currency',
        },
      },
    ]);
  }

  isPresalePurchased(subscription: any) {
    return subscription.is_presale;
  }

  ActionsEmitEvents(event: any) {
    this.emitEvents.emit(event);
    if (event) this.componentInit();
  }

  getTagStyle(tokenStatus: string): string {
    switch (tokenStatus) {
      case 'initiated':
        return 'text-primary';
      case 'confirmed':
        return 'text-green-500';
      case 'rejected':
        return 'text-red-500';
      case 'cancelled':
        return 'text-red-500';
      case 'paused':
        return 'text-red-500';
      default:
        return '';
    }
  }

  getTokenStatusIcon(tokenStatus: string): string {
    switch (tokenStatus) {
      case 'confirmed':
        return 'fa fa-check-circle';
      case 'rejected':
      case 'cancelled':
        return 'fa fa-times-circle';
      case 'paused':
        return 'fa fa-pause-circle';
      default:
        return 'fa fa-question-circle';
    }
  }

  getTokenStatusTooltip(tokenStatus: string): string {
    return `Payment Token Status: ${tokenStatus}`;
  }

  getTokenStatusMessage(tokenStatus: string): string {
    if (tokenStatus === 'confirmed') {
      return 'Token Healthy - Auto billing enabled';
    } else {
      return 'Token Unhealthy - Auto billing disabled';
    }
  }

  get showSkeleton() {
    return this.showSkeleton$.value;
  }

  isPendingForMandatoryAction(status: string): boolean {
    return status.toLowerCase() === 'pendingformandatoryaction';
  }

  showPendingActionsDetails(subscription: any, event: Event) {
    event.stopPropagation();
    if (subscription.pending_for_mandatory_action_details) {
      this.selectedPendingDetails =
        subscription.pending_for_mandatory_action_details;
      this.selectedSubscriptionAutopay =
        subscription.is_autopay_enabled || false;
      this.showPendingActionsPopup = true;
    }
  }

  closePendingActionsPopup() {
    this.showPendingActionsPopup = false;
    this.selectedPendingDetails = null;
    this.selectedSubscriptionAutopay = false;
  }

  HideErrorPopup(event: any) {
    this.showErrorPopup?.next(false);
    this.errorMessages = [];
  }
  
}
